import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  step: {
    alignItems: 'center',
    color: '#a4a4a4',
    display: 'flex',
    fontFamily: 'CircularStd',
    fontSize: 18,
    transition: 'color 0.5s',
    '& .step-icon': {
      alignItems: 'center',
      border: `2px solid #CCC`,
      borderRadius: 100,
      display: 'flex',
      height: 18,
      justifyContent: 'center',
      marginRight: 20,
      width: 18,
      transition: 'background-color 0.5s, border-color 0.5s',
      '& .step-inner': {
        backgroundColor: '#CCC',
        borderRadius: 100,
        display: 'block',
        height: 6,
        width: 6,
        transition: 'background-color 0.5s, width 0.5s, height 0.5s'
      }
    },
    '@media(max-width: 768px)': {
      flexDirection: 'column',
      fontSize: 16,
      '& .step-icon': {
        marginBottom: 10,
        marginRight: 0
      },
      '& .step-label-second-word': {
        display: 'none'
      }
    },
    '@media(max-width: 620px)': {
      fontSize: 12,
      textAlign: 'center',
      padding: '0 2px',
      '& .step-icon': {
        height: 14,
        width: 14
      }
    }
  },
  stepActive: {
    color: '#4a4a4a',
    fontWeight: 600,
    '& .step-icon': {
      backgroundColor: '#2d91e9',
      borderColor: '#2d91e9',
      '& .step-inner': {
        backgroundColor: '#FFFFFF',
        height: 8,
        width: 8
      }
    },
    '@media(max-width: 768px)': {
      fontWeight: 500
    }
  },
  stepComplete: {
    fontWeight: 600,
    '& .step-icon': {
      borderColor: '#2d91e9',
      '& .step-inner': {
        backgroundColor: '#2d91e9'
      }
    },
    '@media(max-width: 768px)': {
      fontWeight: 500
    }
  }
});
